































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OrganizationActions extends Vue {
  @Prop() readonly organizationId!: string;
}
